const categoryToFilterMap = {
  "Hair": "Hair concern",
  "Skin": "Skin concern", 
  "Make Up": "Make Up concern",
  "Hands & Feet": "Hands & Feet concern",
};

const BASE_URL = "https://catalogapi.hulsecure.in/api/website/service";

// ── Detect gender from current page URL ──
function getGenderFromURL() {
  const path = window.location.pathname.toLowerCase();
  if (path.includes("mens-services") && !path.includes("womens")) {
    return "Men's services";  // ← apostrophe was missing
  }
  return "Womens services";
}

let selectedGender   = getGenderFromURL();
let selectedCategory = "";
let selectedSubcategory = "";
let selectedConcern  = "";
let selectedTag = "";
let selectedSort = sessionStorage.getItem("selectedSort") || "";
let womenContainer, menContainer, filterSelect, concernSelect;

function getActiveContainer() {
  return selectedGender === "Womens services" ? womenContainer : menContainer;
}

function buildServiceURL() {
  const params = new URLSearchParams();
  params.set("gender", selectedGender);
  if (selectedCategory)    params.set("category", selectedCategory);
  if (selectedSubcategory) params.set("subcategory", selectedSubcategory);
  if (selectedConcern)     params.set("concern", selectedConcern);
  if (selectedTag)         params.set("tags", selectedTag);
  if (selectedSort)        params.set("sort_by", selectedSort);
  const url = `${BASE_URL}/service-list?${params.toString()}`;
  return `${BASE_URL}/service-list?${params.toString()}`;
}

function buildCardHTML(service) {
  const detailPage = selectedGender === "Womens services" ? "womens" : "mens";
  const titleSlug = service.name.trim().replace(/\s+/g, '').replace(/[^a-zA-Z0-9-]/g, '');
  return `
    <div class="main-card" data-tag="${service.tags ?? ""}" data-concern="${service.concern ?? ""}">
      <label class="custom-checkbox">
        <input type="checkbox">
        <span class="checkmark"></span>
      </label>
      <div class="product-card">
        <div class="service-card">
          <div class="image-media">
            <img src="${service.media_url}" alt="${service.name}" class="service-img"/>
          </div>
          <div class="service-details">
            <h3 class="service-title">${service.name}</h3>
            <p class="service-duration">
              <span class="clock-icon">🕑</span> ${service.duration} mins
            </p>
            <div class="bold-button-cstm">
              <button class="bold-book-now bold-button book-now" data-service-id="${service.id}" data-service-name="${service.name}">BOOK NOW</button>
              <a class="bold-button view-more" href="/pages/${detailPage}?${titleSlug}" onclick="sessionStorage.setItem('serviceId', '${service.id}')">VIEW MORE</a>
            </div>
          </div>
        </div>
      </div>
    </div>`;
}

async function fetchAndRenderServices() {
  const container = getActiveContainer();
  container.innerHTML = `<p class="loading-msg">Loading services…</p>`;
  try {
    const res    = await fetch(buildServiceURL());
    const result = await res.json();
    container.innerHTML = "";
    if (!result.success || !result.data?.length) {
      container.innerHTML = `<p class="no-results">No services found.</p>`;
      return;
    }
    console.log("result", result);
    result.data.forEach(service => {
      container.insertAdjacentHTML("beforeend", buildCardHTML(service));
    });
  } catch (err) {
    console.error("Service fetch error:", err);
    container.innerHTML = `<p class="error-msg">Failed to load. Please try again.</p>`;
  }
}

async function loadCategoryOptions() {
  try {
    const res    = await fetch(`${BASE_URL}/filters-list`);
    const result = await res.json();
    if (result.success && result.data) {
      filterSelect.innerHTML = `<option value="">Select Filter</option>`;
      const excludedFilters = new Set(Object.values(categoryToFilterMap));
      result.data.forEach(item => {
        if (excludedFilters.has(item)) return;
        const opt       = document.createElement("option");
        opt.value       = item;
        opt.textContent = item;
        filterSelect.appendChild(opt);
      });
    }
  } catch (err) {
    console.error("Filter fetch error:", err);
  }
}

async function loadConcernOptions(categoryName, subcategoryName = "") {
  concernSelect.innerHTML     = `<option value="">Select Concern</option>`;
  concernSelect.style.display = "none";
  if (!categoryName) return;
  try {
    let url = `${BASE_URL}/concern-list?cat_name=${encodeURIComponent(categoryName)}`;
    if (subcategoryName) url += `&subcat_name=${encodeURIComponent(subcategoryName)}`;
    const res    = await fetch(url);
    const result = await res.json();
    if (result.success && result.data?.length) {
      result.data.forEach(item => {
        const opt       = document.createElement("option");
        opt.value       = item;
        opt.textContent = item;
        concernSelect.appendChild(opt);
      });
      concernSelect.style.display = "block";
    }
  } catch (err) {
    console.error("Concern fetch error:", err);
  }
}

function resetFilters() {
  selectedCategory            = "";
  selectedSubcategory         = "";
  selectedConcern             = "";
  selectedTag                 = "";
  filterSelect.value          = "";
  concernSelect.innerHTML     = `<option value="">Select Concern</option>`;
  concernSelect.style.display = "none";
}

function showActiveContainer() {
  if (selectedGender === "Womens services") {
    womenContainer.style.display = "block";
    menContainer.style.display   = "none";
  } else {
    womenContainer.style.display = "none";
    menContainer.style.display   = "block";
  }
}

function syncGenderButtons() {
  document.querySelectorAll(".gender-btn").forEach(btn => {
    btn.classList.toggle("active", btn.getAttribute("data-gender") === selectedGender);
  });
}

async function handleGenderSwitch(gender) {
  if (gender === selectedGender) return;

  selectedGender = gender;

  const genderParam = gender === "Womens services" ? "womens" : "mens";
  document.getElementById("subcategoryList").innerHTML = "";
  loadCategories(genderParam);

  showActiveContainer();
  syncGenderButtons();
  resetFilters();
  await fetchAndRenderServices();
}

// -------------------- CATEGORY LOAD --------------------
function loadCategories(gender = "womens") {
  fetch(`https://catalogapi.hulsecure.in/api/website/service/getCategoryOrSubcategory?gender=${gender}`)
    .then((response) => response.json())
    .then((result) => {
      const data = result.data;
      const container = document.getElementById("categoryList");
      container.innerHTML = "";

      data.forEach((item) => {
        const div = document.createElement("div");
        div.classList.add("category-item");
        div.innerHTML = `
          <img src="${item.image}" class="category-img" />
          <p>${item.category}</p>
        `;

        div.addEventListener("click", function () {
          const subContainer = document.getElementById("subcategoryList");

          // Toggle off if already opened
          if (div.classList.contains("opened")) {
            document.querySelectorAll(".category-item").forEach(el => {
              el.style.display = "flex";
              el.classList.remove("opened", "active");
            });

            subContainer.innerHTML = "";
            selectedCategory = "";
            selectedSubcategory = "";

            const tempOpt = filterSelect.querySelector("option[data-temp='true']");
            if (tempOpt) tempOpt.remove();

            filterSelect.value = "";
            fetchAndRenderServices();
            return;
          }

          selectedCategory    = item.category;
          selectedSubcategory = "";
          console.log("Category:", selectedCategory);

          // Remove previous temp option
          const prevTemp = filterSelect.querySelector("option[data-temp='true']");
          if (prevTemp) prevTemp.remove();

          // Add mapped concern filter as temp option
          const mappedFilter = categoryToFilterMap[item.category];
          if (mappedFilter) {
            const opt = document.createElement("option");
            opt.value = mappedFilter;
            opt.textContent = mappedFilter;
            opt.dataset.temp = "true";
            filterSelect.appendChild(opt);
          }

          filterSelect.value = "";
          fetchAndRenderServices();

          document.querySelectorAll(".category-item").forEach(el => {
            el.style.display = "none";
            el.classList.remove("opened");
          });
          div.style.display = "flex";
          div.classList.add("active", "opened");

          fetchSubcategories(item.category);
        });

        container.appendChild(div);
      });
    })
    .catch((error) => console.error(error));
}

// -------------------- FETCH SUBCATEGORIES --------------------
function fetchSubcategories(categoryName) {
  if (!categoryName) {
    console.error("Category name is required");
    return;
  }
  const container = document.getElementById("subcategoryList");
  fetch(`https://catalogapi.hulsecure.in/api/website/service/getCategoryOrSubcategory?cat_name=${encodeURIComponent(categoryName)}`)
    .then((response) => response.json())
    .then((result) => {
      const data = result.data || [];
      container.innerHTML = "";
      if (data.length > 0) {
        data.forEach((item, index) => {
          const div = document.createElement("div");
          div.classList.add('category-item-cstm', `category-item-${index + 1}`);
          const subcategoryName = typeof item === 'string'
            ? item
            : item.subcategory || item.name || "Unknown";
          div.innerHTML = `<p>${subcategoryName}</p>`;
          div.addEventListener("click", function (event) {
            fetchData(categoryName, subcategoryName, event);
          });
          container.appendChild(div);
        });
      } else {
        container.innerHTML = "<p>No subcategories found</p>";
      }
    })
    .catch((error) => {
      console.error("Error fetching subcategories:", error);
      container.innerHTML = "<p>Error loading subcategories</p>";
    });
}

// -------------------- FETCH DATA (subcategory click) --------------------
function fetchData(categoryName, subcategoryName, event) {
  if (!categoryName || !subcategoryName) {
    console.error("Category and subcategory are required");
    return;
  }

  document.querySelectorAll(".category-item-cstm").forEach(el => el.classList.remove("active"));
  event.currentTarget.classList.add("active");

  selectedCategory    = categoryName;
  selectedSubcategory = subcategoryName;
  selectedConcern     = "";
  concernSelect.value = "";

  const mappedVal = categoryToFilterMap[categoryName];
  if (mappedVal) {
    if (filterSelect.value === mappedVal) {
      loadConcernOptions(categoryName, subcategoryName);
    } else {
      concernSelect.innerHTML = `<option value="">Select Concern</option>`;
      concernSelect.style.display = "none";
    }
  } else {
    filterSelect.value = "";
    concernSelect.innerHTML = `<option value="">Select Concern</option>`;
    concernSelect.style.display = "none";
  }

  fetchAndRenderServices();
}

// -------------------- DOM READY --------------------
document.addEventListener("DOMContentLoaded", async () => {
  womenContainer = document.querySelector(".woman-cstm-api");
  menContainer   = document.querySelector(".man-cstm-api");
  filterSelect   = document.getElementById("filterSelect");
  concernSelect  = document.getElementById("concernSelect");

  // Derive gender param from URL-detected selectedGender
  const genderParam = selectedGender === "Womens services" ? "womens" : "mens";

  loadCategories(genderParam);
  syncGenderButtons();

  // Gender button listeners
  document.querySelectorAll(".gender-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      handleGenderSwitch(this.getAttribute("data-gender"));
    });
  });

  // Filter (tag / concern-category) change
  filterSelect.addEventListener("change", function () {
    const value = this.value;

    selectedConcern = "";
    selectedTag = "";
    concernSelect.value = "";

    const concernValues = Object.values(categoryToFilterMap);

    if (concernValues.includes(value)) {
      const originalCategory = Object.keys(categoryToFilterMap).find(
        key => categoryToFilterMap[key] === value
      );
      loadConcernOptions(originalCategory);
    } else {
      selectedTag = value;
      concernSelect.innerHTML = `<option value="">Select Concern</option>`;
      concernSelect.style.display = "none";
    }

    fetchAndRenderServices();
  });

  // Concern change
  concernSelect.addEventListener("change", function () {
    selectedConcern = this.value;
    fetchAndRenderServices();
  });

  // Sort select
  const selectBox = document.getElementById("sortSelect");
  selectBox.value = selectedSort;
  selectBox.addEventListener("change", function () {
    selectedSort = this.value;
    sessionStorage.setItem("selectedSort", selectedSort);
    fetchAndRenderServices();
  });

  womenContainer.style.display = "none";
  menContainer.style.display   = "none";

  await loadCategoryOptions();
  showActiveContainer();
  syncGenderButtons();
  await fetchAndRenderServices();
});